export default function StatCard({label,value,secondaryValue, target}){
	return (
	<div className="stat-card">
		<p className="label">{label}</p>
		<h3 className="value">{value}</h3>
		{secondaryValue && <><h1>/</h1> <p className="secondary-value">{secondaryValue}</p></>}
		{target &&
			<div className="progress-bar">
				<div className="background"><div className="foreground" style={{"width": `${(value/target)*100}%`}}></div></div>
				<p className="value">{target}</p>
			</div>
		}

	</div>
	);
}
export  function SmallStatCard({label,value}){
	return (
	<div className="stat-card small-stat-card">
		<h3 className="value">{value}</h3>
		<p className="label">{label}</p>

	</div>
	);
}

